import request from "@/services/request";
import baseUrl from "@/services/baseUrl";

export default {
    async getMerchantInfo(){
        const info = localStorage.getItem('tz-cortex-merchant-info');
        if(info){
            return JSON.parse(info)
        } else{
            let data = {};
           await request.get(baseUrl.main + "/fapi/v1/userv2/info").then(res=>{
                if(res.success){
                    localStorage.setItem('tz-cortex-merchant-info',JSON.stringify(res.data));
                    data = res.data;
                }

            }).catch(err=>{
                console.error(err);
            })
            return data;
        }
    },
    uncompletedFlowStatus: [
        {
            1: 'pending',
            10: 'pending',
            11: 'pendingApproval',
            21: 'authRequired',
            2: 'payInProgress',
            3: 'completed',
            '-1': 'failed',
            '-2': 'cancelled',
            '-20': 'inboundExternalPaymentFailed',
            '-10': 'cancelled'
        },
        {
            10: 'dark',
            11: 'primary',
            2: 'warning',
            21: 'warning',
            3: 'success',
            '-1': 'danger',
            '-10': 'danger',
            '-20': 'danger',
            '-2': 'danger'
        }
    ],
    transactionStatus: [
        {
            10: "pending",
            40: "completed",
            20: "pendingInboundPayment",
            21: "inboundPaymentRedirectionRequired",
            22: "inboundPaymentRedirectionURLGenerationInProgress",
            32: "thirdPartyProcessing", // no wait
            '-44': "expired",
            '-45': "failedByAdmin",
            '-46': "refundInProgress",
            '-31': "cashOutFailed",
            '-10': "reversed",
            '-41': "refunded",
            '-42': "refunded",
            '-43': "cancelled",
            '-22': "externalPaymentFailed",
            7: "onHold",
            '-40': "failed",
            '-20': "inboundExternalPaymentFailed",
            11: "payInProgress",
            12: "extPayPending",
            30: "thirdPartyProcessing",
            31: "thirdPartyProcessing",
            13: "authRequired",
        },
        {
            10: "dark",
            40: "success",
            20: "warning",
            21: "warning",
            22: "warning",
            32: "warning", // no wait
            '-44': "danger",
            '-45': "danger",
            '-46': "warning",
            '-31': "danger",
            '-10': "danger",
            '-41': "warning",
            '-42': "warning",
            '-43': "danger",
            '-22': "danger",
            7: "warning",
            '-40': "warning",
            '-20': "warning",
            11: "primary",
            12: "warning",
            30: "warning",
            31: "warning",
            13: "warning",
            'undefined': "dark",
        },
    ],
    transactionServiceLinks: {
        4: '/account/refunds?refundId=',
        7: '/account/refunds?refundId=',
        11: '/payment-links/view?id=',
        13: '/mass-payments/',
        19: '/transactions/automatic-settlement?settlementId=',
        2: '/invoice/view/',
        26: '/transfer/',
        15: '/transfer/',
    },
    payoutStatusMap: Object.freeze({
        draft: 10,
        pending: 1,
        pendingApproval: 12,
        attentionRequired: -12,
        approved: 13,
        queued: 2,
        queued2: 21, // still processing
        processing: 3,
        completed: 4,
        canceled: -2,
        failed: -1,
        internalTransferCompleted: 7,
    }),
    payoutStatusesAndColors: [
        {
            10: 'draft',
            1: 'pending',
            12: 'pendingApproval',
            13: 'approved',
            2: 'queued',
            21: 'queued',
            '-21': 'attentionRequired',
            3: 'processing',
            4: 'completed',
            '-2': 'cancelled',
            '-1': 'failed',
            7: 'processing',
            40: 'partiallyCompleted',
        },
        {
            10: 'alert-dark',
            1: 'alert-dark',
            12: 'alert-warning',
            13: 'alert-primary',
            2: 'alert-warning',
            21: 'alert-warning',
            '-21': 'alert-warning',
            3: 'alert-warning',
            4: 'alert-success',
            '-2': 'alert-danger',
            '-1': 'alert-danger',
            7: 'alert-warning',
            40: 'alert-warning',
        }
    ],
    transferStatusMap: Object.freeze({
        pending: 1,
        pendingApproval: 11,
        approved: 12,
        processing: 2,
        completed: 3,
        retryRequired: -2,
        canceled: -2,
        failed: -1,
    }),
    transferTypesMap: Object.freeze({
        internal: 1,
        mobileWallet: 2,
        bankDebit: 3,
        topUp: 4,
        accountTransfer: 5
    }),
    inboundTransactionStatusMap: Object.freeze({
        pending: 1,
        queued: 2,
        partnerRequestSubmitted: 3,
        partnerRequestCompleted: 4,
        completed: 5,
        pendingUrlGeneration: 6,
        failed: -1,
        cancelled: -2,
        refundRequired: -3,
        refundInitiated: -31,
        refundFailed: -32,
        refunded: -4,
        topUp: 4,
        accountTransfer: 5
    }),
    inboundTransactionStatusesAndColors: [
        {
            1: 'pending',
            2: 'queued',
            3: 'partnerRequestSubmitted',
            4: 'partnerRequestCompleted',
            5: 'completed',
            6: 'pendingUrlGeneration',
            '-1': 'failed',
            '-2': 'cancelled',
            '-3': 'refundRequired',
            '-31': 'refundInitiated',
            '-32': 'refundFailed',
            '-4': 'refunded'
        },
        {
            1: 'alert-dark',
            2: 'alert-warning',
            3: 'alert-warning',
            4: 'alert-primary',
            5: 'alert-success',
            6: 'alert-warning',
            '-1': 'alert-danger',
            '-2': 'alert-danger',
            '-3': 'alert-warning',
            '-31': 'alert-warning',
            '-32': 'alert-danger',
            '-4': 'alert-warning'
        }
    ],
    transferRouteNames: Object.freeze({
        1: 'transfer-to-tranzak-user',
        2: 'transfer-to-mobile-money-account',
        3: 'transfer-to-bank-account',
        4: 'account-balance', //for top ups
        5: 'transfer-to-linked-account'
    }),
    transferApiNames: Object.freeze({
        1: 'toUser',
        2: 'toMobileMoneyAccount',
        3: 'toAccount',
        4: 'topUp', //for top ups
        5: 'betweenAccounts'
    }),
    transferStatusesAndColors: [
        {
            1: 'pending',
            11: 'pendingApproval',
            12: 'approved',
            2: 'processing',
            21: 'processing',
            3: 'completed',
            '-2': 'retryRequired',
            '-12': 'attentionRequired',
            '-3': 'cancelled',
            '-1': 'failed'
        },
        {
            1: 'alert-dark',
            11: 'alert-warning',
            21: 'alert-warning',
            12: 'alert-primary',
            2: 'alert-warning',
            3: 'alert-success',
            '-12': 'alert-warning',
            '-2': 'alert-warning',
            '-3': 'alert-danger',
            '-1': 'alert-danger'
        }
    ]
}